import { render, staticRenderFns } from "./sqlIDE.vue?vue&type=template&id=6945e9d2"
import script from "./sqlIDE.vue?vue&type=script&lang=js"
export * from "./sqlIDE.vue?vue&type=script&lang=js"
import style0 from "./sqlIDE.vue?vue&type=style&index=0&id=6945e9d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports